$(document).ready(function() {
//   $(".mega-child-images").hover(
//   function () {
//     var parentItem = $(this).closest(".mega-item-menus");
//     var megamenu = $(this).closest(".mega-menu__item");
  
//     $(".mega-menu__item:not([class*='shows-mega-items'])").addClass("hiddens-menus");
//    if ($(".mega-menu__item").hasClass("shows-mega-items")) {
//       $(".mega-menu__item").removeClass("shows-mega-items");
//     $(".mega-menu__item").addClass("hiddens-menus");
     
// }
    
    
//   },
//   function () {
//   $(this).closest(".mega-menu__item").removeClass("hover-over-items");
//     $(".mega-menu__item:not([class*='shows-mega-items'])").removeClass("hiddens-menus");
//   }
// );



$('.testimonial-sliders').slick({
  dots: true,
  infinite: true,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
 /* Slick slider for featured collections*/
var $slider = $('.collection-sliders');
var $progressBar = $('.progress');
var $progressBarLabel = $('.slider__label');

function initializeSlider() {
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc);

    $progressBarLabel.text(calc + '% completed');
  });

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 400,
    arrows:false,
  infinite: false

  });
}

function destroySlider() {
  $slider.slick('unslick');
}

if (window.innerWidth > 768) {
 
var $swiperSelector = $('.swiper-container');

$swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    
    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 200;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;
    var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 4;
    var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 3;
    var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 2;
    var spaceBetween = $this.data('space-between') ? $this.data('space-between'): 20;

    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      breakpoints: {
        1280: {
          slidesPerView: slidesDesktop
        },
        992: {
          slidesPerView: slidesTablet
        },
        320: {
           slidesPerView: slidesMobile
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: dragSize
      }
   });
});
} 



});